import { Box, Typography } from '@mui/material';
import Link from 'next/link';

import { LOCATION_ROUTES } from '@/helpers/locationPages';

import { Card } from './LocationList.style';

function LocationsList({ locations = [] }) {
  return (
    <Box sx={{ columnCount: { xs: 1, sm: 2, md: 3 }, marginBlock: 8 }}>
      {locations.map((loc, idx) => (
        <Card key={idx} elevation={0}>
          <Typography variant="h6Redesign" color="primary.dark">
            {loc.state}
          </Typography>
          {loc.cities.map(city => (
            <Link
              key={city.id}
              href={`${LOCATION_ROUTES.BASE_PATH}/${city.slug}`}>
              {city.name}
            </Link>
          ))}
        </Card>
      ))}
    </Box>
  );
}

export default LocationsList;
